export var Mixing;
(function (Mixing) {
    Mixing[Mixing["Linear"] = 0] = "Linear";
    Mixing[Mixing["EqualPower"] = 1] = "EqualPower";
})(Mixing || (Mixing = {}));
